module.exports = __webpack_public_path__ + "static/media/avtocontrol.b13eb625.jpg";